<template>
  <div class="md-layout">


    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>Activities</md-icon>
          </div>
          <h4 class="title">Labourers Terminated List</h4>


        </md-card-header>
        <md-card-content>
          <div class="text-right">
            <md-button @click="goToList" class="md-primary md-dense">
              Back to List
            </md-button>
          </div>
          <md-table
              :value="table"
              :md-sort.sync="sortation.field"
              :md-sort-order.sync="sortation.order"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                    v-model="query"
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px"
                    placeholder="Search ..."
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Full Name" md-sort-by="first_name">
                {{ item.first_name + " " + item.middle_name + " " + item.last_name }}
                <br/>
                <badge type="info" class="mt-2">{{ item.nida_number }}</badge>
              </md-table-cell>
              <md-table-cell md-label="Phone Number" md-sort-by="phone_number">
                {{ item.phone_number }}
              </md-table-cell>
              <md-table-cell md-label="Takeon Count" md-sort-by="takeon_count">
                {{ item.takeon_count }}
              </md-table-cell>
              <md-table-cell md-label="Gender" md-sort-by="gender">
                {{ item.gender }}
              </md-table-cell>
              <md-table-cell md-label="Port" md-sort-by="port">
                <span v-if="item.port" class="text-muted"> {{ item.port.name }}</span>
              </md-table-cell>
              <md-table-cell md-label="Department" md-sort-by="department">
                <span v-if="item.department"> {{ item.department.name }}</span>
                <span v-if="item.department && item.department.port"
                      class="text-muted"> (Port: {{ item.department.port.name }})</span>
              </md-table-cell>
              <md-table-cell md-label="Skilled">
  <span
      class="clickable-count"
      @click="showSkills(item)"
  >
    {{
      item.skills && item.skills.length > 0
          ? item.skills.length
          : 'None'
    }}
  </span>
              </md-table-cell>
              <md-table-cell md-label="Labourer Number" md-sort-by="vendor_labourer_number">
                {{ item.vendor_labourer_number }}
                <br/>
                <badge type="rose" class="mt-1">{{ item.vendor ? item.vendor[0].short_name : 'No Vendor' }}</badge>
              </md-table-cell>
              <md-table-cell md-label="Status" md-sort-by="status">

                            <span v-if="item.latest_status" class="text-muted">
                               <badge
                                   :type="item.latest_status.name==='Active'?'success':(item.latest_status.name==='Suspended'?'warning':'danger')"
                                   class="mt-2">{{ item.latest_status.name }}
                                  </badge>
                            </span>

              </md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                    class="md-icon-button md-raised md-round md-success"
                    @click="openActivateDialog(item)"
                    style="margin: 0.2rem"
                    v-if="item.latest_status && item.latest_status.name === 'Terminated'"
                >
                  <md-icon>how_to_reg</md-icon>
                </md-button>

              </md-table-cell>
            </md-table-row>
          </md-table>

          <div class="footer-table md-table">
            <table>
              <tfoot>
              <tr>
                <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                >
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">
                      {{ item }}
                    </div>
                  </div>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
          />
        </md-card-actions>
      </md-card>
    </div>

    <md-dialog :md-active.sync="dialog.active">
      <md-dialog-title>{{ dialog.title }}</md-dialog-title>

      <md-dialog-content>
        <md-list v-if="dialog.items.length">
          <md-list-item v-for="(item, index) in dialog.items" :key="index">
            {{ index + 1 }}. {{ item.name }}
          </md-list-item>
        </md-list>
        <p v-else class="text-center">No data available.</p>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="dialog.active = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="activateDialog.active">

      <md-dialog-title>
        Reactivate Labourer
      </md-dialog-title>

      <md-dialog-content>

        <md-field>
          <label>Vendor Labourer Number</label>

          <md-input
              v-model="activateDialog.form.vendor_labourer_number"
          />
        </md-field>

      </md-dialog-content>

      <md-dialog-actions>

        <md-button
            class="md-primary"
            @click="activateDialog.active = false"
        >
          Cancel
        </md-button>

        <md-button
            class="md-success"
            @click="submitActivate"
            :disabled="activateDialog.loading"
        >
          Reactivate
        </md-button>

      </md-dialog-actions>

    </md-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert2';
import Badge from '@/components/Badge.vue';

export default {
  components: {
    Badge,
    pagination: Pagination,
  },

  data: () => ({
    dialog: {
      active: false,
      title: '',
      items: []
    },
    activateDialog: {
      active: false,
      labourer: null,
      loading: false,
      form: {
        vendor_labourer_number: '',
      },
    },
    table: [],
    statuses: [],
    filteredStatus: null,

    footerTable: [
      'Full Name',
      // 'NIDA Number',
      'Phone Number',
      'TakeOn Count',
      // 'Tribe',
      'Gender',
      'Port',
      'Department',
      'Skilled',
      'Labourer Number',
      'Status',
      // 'Created At',
      'Actions'],

    query: null,

    sortation: {
      field: 'created_at',
      order: 'asc',
    },

    pagination: {
      perPage: 10,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 400, 500, 600, 700, 800, 900, 1000],
    },

    total: 0,
  }),

  computed: {
    sort() {
      if (this.sortation.order === 'desc') {
        return `-${this.sortation.field}`;
      }
      return this.sortation.field;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: 'getListDebounced',
      immediate: true,
    },
    sortation: {
      handler: 'getList',
      immediate: false,
      deep: true,
    },
    pagination: {
      handler: 'getList',
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.getStatusCounts();
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      let params = {
        include: 'port,vendor,skills,department',
        ...(this.sort ? {sort: this.sort} : {}),
        // filter: {
        //     ...(this.query ? { query_key: this.query } : {}),
        // },
        filter: {
          ...(this.query ? {query_key: this.query} : {}),
          ...(this.filteredStatus && this.filteredStatus !== 'Total'
              ? {status: this.filteredStatus}
              : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      try {
        await this.$store.dispatch('labourers/terminated', params);
        const response = this.$store.getters['labourers/terminated'];
        this.table = response || [];
        this.total = this.$store.getters['labourers/listTotal'];
      } catch (e) {
        this.notifyException(e);
      }
    },
    // async labourerStatuesFilter (status) {
    //   this.filteredStatus = status;
    //   await this.getList();
    // },
    async labourerStatuesFilter(status) {

      // Toggle filter off if same status clicked
      if (this.filteredStatus === status || status === 'Total') {
        this.filteredStatus = null;
      } else {
        this.filteredStatus = status;
      }

      this.pagination.currentPage = 1;

      await this.getList();
    },
    async getStatusCounts() {
      try {
        await this.$store.dispatch('labourers/statusStatistics');
        this.statuses = this.$store.getters['labourers/statistics'];
      } catch (e) {
        console.error('Failed to fetch status counts', e);
        this.statuses = [];
        this.notifyException(e);
      }
    },

    async destroy(activity) {
      const confirmation = await Swal.fire({
        title: 'Delete this data?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
      });

      if (confirmation.value === true) {
        try {
          await this.$store.dispatch('labourers/destroy', activity);
          await this.$store.dispatch(
              'alerts/success',
              'Labourer deleted successfully.'
          );
          await this.getList();
        } catch (e) {
          if (e.response.data.errors[0]) {
            await this.$store.dispatch(
                'alerts/error',
                e.response.data.errors[0].title
            );
          } else {
            this.notifyException(e);
          }
        }
      }
    },

    goToList() {
      this.$router.push({name: 'Labourers List'});
    },

    goToEdit(id) {
      this.$router.push({name: 'Edit Labourer', params: {id}});
    },

    goToView(id) {
      this.$router.push({name: 'View Labourer', params: {id}});
    },


    customSort() {
      return false;
    },

    async showSkills(labourer) {
      try {
        this.dialog.title = `Skills for ${labourer.name}`;
        this.dialog.items = labourer.skills;
        this.dialog.active = true;
      } catch (e) {
        this.notifyException(e);
      }
    },
    openActivateDialog(labourer) {

      this.activateDialog.labourer = labourer;

      this.activateDialog.form = {
        vendor_labourer_number: '',
      };

      this.activateDialog.active = true;
    },
    async submitActivate() {

      try {

        this.activateDialog.loading = true;

        const response =
            await this.$store.dispatch(
                'labourers/activateToVendor',
                {
                  id: this.activateDialog.labourer.id,
                  data: this.activateDialog.form,
                }
            );

        await this.$store.dispatch(
            'alerts/success',
            response.message ||
            'Labourer reactivated successfully.'
        );

        this.activateDialog.active = false;

        await this.getList();

      } catch (e) {

        if (e.response && e.response.data && e.response.data.message) {

          await this.$store.dispatch(
              'alerts/error',
              e.response.data.message
          );

        } else {

          this.notifyException(e);
        }

      } finally {

        this.activateDialog.loading = false;
      }
    },
  },
};
</script>
<style>
.active-status-card {
  border: 2px solid #2196f3;
  cursor: pointer;
  transform: scale(1.02);
  transition: 0.2s ease;
}
</style>
